import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import config from './modules/config'
import timeout from './modules/timeout'
import permissoesAcesso from './modules/permissoesAcesso'

Vue.use(Vuex)

// this.$can('VEICULOS', 'DELETE') nos componentes; ver store/modules/permissoesAcesso.js
Vue.prototype.$can = function (tela, tipo) {
  return this.$store.getters['permissoesAcesso/can'](tela, tipo)
}

export default new Vuex.Store({
  modules: {
    user,
    config,
    timeout,
    permissoesAcesso
  }
})
